import type { LeadSurveyPayload, LeadSurveyResponse } from './types';

import { BASE_URL } from '../constants';
import { post } from '../requestMethods';

const URL = `${BASE_URL}/api/leadSurvey`;

export const LEAD_SURVEY_API = {
  postLeadSurvey: (data: LeadSurveyPayload) => post<LeadSurveyResponse>(URL, { data }),
};

export type { LeadSurveyPayload, LeadSurveyResponse } from './types';
